module.exports = function() {
  return new Worker(__webpack_public_path__ + "2ab2408e067a6bf63669.worker.js");
};